import axios from 'axios';

// Single axios instance for all backend calls. withCredentials is required so the
// httpOnly session cookie set by /api/auth/google/callback is sent on every request.
export const apiClient = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL ?? '/api',
  withCredentials: true,
  timeout: 15_000,
});

export interface ApiErrorShape {
  error: string;
  message: string;
  statusCode: number;
}

export function isApiError(err: unknown): err is { response: { data: ApiErrorShape; status: number } } {
  return axios.isAxiosError(err) && Boolean(err.response?.data?.error);
}

export function getApiErrorMessage(err: unknown): string {
  if (isApiError(err)) return err.response.data.message;
  if (err instanceof Error) return err.message;
  return 'Something went wrong. Please try again.';
}
